import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-back-drop',
    templateUrl: './back-drop.component.html',
    styleUrls: ['./back-drop.component.scss'],
    standalone: false
})
export class BackDropComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
